export default __webpack_public_path__ + "static/media/Shal-e-Pashm_compressed.587f25fb.pdf";